import { observer } from "mobx-react-lite";
import { Marker, Tooltip } from "react-leaflet";
import { divIcon } from "leaflet";
import { useStores } from "stores/setup/use-store";
import greenMarker from "assets/green-marker.svg";
import { TooltipContent } from "components/TooltipComponent/ToolltipComponent";

/**
 * Renders a marker for custom selected points (station_id === 0) in Point Selection Mode.
 * This allows users to select any point on the map, not just existing stations.
 */
const CustomPointMarker = () => {
  const {
    dataStores: { insightAlertStore, forecastChartPageStore },
  } = useStores();

  const selectedStation = insightAlertStore.selectedStationForAlert;

  // Only render if there's a custom point selected (station_id === 0)
  if (!selectedStation || selectedStation.station_id !== 0) {
    return null;
  }

  const customPointMarkerIcon = divIcon({
    html: `<img src="${greenMarker}" alt="custom point" style="width: 25px; height: 30px;" />`,
    iconSize: [25, 30],
    iconAnchor: [12.5, 30],
    className: "",
  });

  return (
    <Marker
      position={[selectedStation.station_lat, selectedStation.station_lon]}
      icon={customPointMarkerIcon}
    >
      <Tooltip>
        <TooltipContent
          zoomLevel={forecastChartPageStore.mapZoom}
          title={selectedStation.station_name}
        />
      </Tooltip>
    </Marker>
  );
};

export default observer(CustomPointMarker);
